import { render } from "./MarketStatus.vue?vue&type=template&id=a5733500"
import script from "./MarketStatus.vue?vue&type=script&lang=js"
export * from "./MarketStatus.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MarketStatus.vue?vue&type=style&index=0&id=a5733500&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__